'use client';

import { useEffect, useState } from 'react';
import AppImage from '@/components/ui/AppImage';

const LoadingScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    // Check if loading screen was already shown this session
    const hasShownLoading = sessionStorage.getItem('hasShownLoading');
    
    if (hasShownLoading) {
      // Skip loading screen if already shown
      setIsLoading(false);
      return;
    }

    // Force scroll to top and prevent scrolling during load
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden';
    
    // Preload logo image before showing loader
    const img = new Image();
    img.src = '/assets/images/LoadingLogo.png';
    img.onload = () => {
      // Logo loaded - now show the loading screen
      setShowLoader(true);
      
      // Start fade-out after 2s
      const fadeTimer = setTimeout(() => {
        setFadeOut(true);
      }, 2000);

      // Remove component after fade completes
      const removeTimer = setTimeout(() => {
        setIsLoading(false);
        document.body.style.overflow = 'unset';
        // Mark as shown for this session
        sessionStorage.setItem('hasShownLoading', 'true');
      }, 2500);

      // Cleanup function for timers
      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(removeTimer);
      };
    };

    // Cleanup function for body overflow
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  if (!isLoading) return null;
  if (!showLoader) return null; // Don't show until logo is loaded

  return (
    <div data-component-id="src/components/common/LoadingScreen.tsx:62:4" data-component-path="src/components/common/LoadingScreen.tsx" data-component-line="62" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      className={`fixed inset-0 z-[9999] bg-white flex items-center justify-center ${
        fadeOut ? 'animate-loading-fade-out' : ''
      }`}
      role="progressbar"
      aria-label="Loading page"
      aria-valuetext="Please wait while the page loads"
    >
      <div data-component-id="src/components/common/LoadingScreen.tsx:70:6" data-component-path="src/components/common/LoadingScreen.tsx" data-component-line="70" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20flex%20items-center%20justify-center%22%7D" className="relative flex items-center justify-center">
        {/* Spinning ring loader */}
        <div data-component-id="src/components/common/LoadingScreen.tsx:72:8" data-component-path="src/components/common/LoadingScreen.tsx" data-component-line="72" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20w-40%20h-40%20sm%3Aw-52%20sm%3Ah-52%22%7D" className="absolute w-40 h-40 sm:w-52 sm:h-52">
          <div data-component-id="src/components/common/LoadingScreen.tsx:73:10" data-component-path="src/components/common/LoadingScreen.tsx" data-component-line="73" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20h-full%20border-4%20border-gray-100%20rounded-full%22%7D" className="w-full h-full border-4 border-gray-100 rounded-full" />
          <div data-component-id="src/components/common/LoadingScreen.tsx:74:10" data-component-path="src/components/common/LoadingScreen.tsx" data-component-line="74" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20w-full%20h-full%20border-4%20border-transparent%20border-t-black%20border-r-black%20rounded-full%20animate-spin-ring%22%7D" className="absolute inset-0 w-full h-full border-4 border-transparent border-t-black border-r-black rounded-full animate-spin-ring" />
        </div>

        {/* Logo with reveal animation */}
        <div data-component-id="src/components/common/LoadingScreen.tsx:78:8" data-component-path="src/components/common/LoadingScreen.tsx" data-component-line="78" data-component-file="LoadingScreen.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-28%20h-28%20sm%3Aw-36%20sm%3Ah-36%20animate-logo-reveal%22%7D" className="relative w-28 h-28 sm:w-36 sm:h-36 animate-logo-reveal">
          <AppImage data-component-id="src/components/common/LoadingScreen.tsx:79:10" data-component-path="src/components/common/LoadingScreen.tsx" data-component-line="79" data-component-file="LoadingScreen.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22src%22%3A%22%2Fassets%2Fimages%2FLoadingLogo.png%22%2C%22alt%22%3A%22Ali%20Fiverr%20Coach%20Logo%22%2C%22className%22%3A%22w-full%20h-full%20object-contain%22%7D"
            src="/assets/images/LoadingLogo.png"
            alt="Ali Fiverr Coach Logo"
            className="w-full h-full object-contain"
            priority
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
